<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div>
              <div class="card-header bg-transparent d-flex justify-content-between align-items-center border-0">
                <h3 class="m-0">Últimos Cobros</h3>
                <div>
                  <base-button
                    @click="fireModalIncomingPayment()"
                    size="sm"
                    icon="fa fa-plus"
                  >
                    Nuevo Cobro
                  </base-button>
                </div>
              </div>
              <TableIncPayments ref="tableIP"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal New Incoming Payment -->
    <b-modal
      v-model="modals.incomingPayment"
      id="modalIncomingPayment"
      size="custom-size"
      bodyClass="p-0"
      hide-footer
      hide-header
    >
      <NewIncPayment
        v-if="modals.incomingPayment"
        @reload="reloadTable()"
        @close="modals.incomingPayment = false"
      />
    </b-modal>
  </div>
</template>

<script>
import NewIncPayment from "./NewIncPayment.vue";
import TableIncPayments from "./TableIncPayments.vue";

export default {
  components: {
    NewIncPayment,
    TableIncPayments
  },
  data() {
    return {
      modals: {
        incomingPayment: false,
      },
    };
  },
  methods: {
    reloadTable() {
      this.$refs.tableIP.reloadTable();
    },
    fireModalIncomingPayment() {
      this.modals.incomingPayment = true;
    },
  },
};
</script>

<style>
.modal-custom-size {
  max-width: 900px;
}
</style>
